import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { OrgTypes } from '@mode/shared/contract-common';

export type ColorPalettePreviewSwatchSize = 'small' | 'large' | 'full-width';

@Component({
  selector: 'mode-color-palette-preview-swatch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './color-palette-preview-swatch.component.html',
  styleUrls: ['./color-palette-preview-swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorPalettePreviewSwatchComponent implements OnInit, OnChanges {
  @Input() selectedColorPalette: OrgTypes.ColorPalette | null = null;
  @Input() size: ColorPalettePreviewSwatchSize = 'large';
  @Input() limit = 5;

  palette: string[] = [];

  ngOnInit(): void {
    this.initializePalette();
  }

  ngOnChanges() {
    this.initializePalette();
  }

  initializePalette() {
    if (this.selectedColorPalette?.type === OrgTypes.ColorPaletteType.Categorical) {
      this.palette = this.selectedColorPalette.value
        .split(',')
        .slice(0, this.limit)
        .map((color) => color.trim());
    } else if (this.selectedColorPalette) {
      const maxColors = this.selectedColorPalette.type === OrgTypes.ColorPaletteType.Divergent ? 3 : 2;
      const colorList = this.selectedColorPalette.value.split(',').slice(0, maxColors).join(',');
      this.palette = [`linear-gradient(to right, ${colorList})`];
    }
  }
}
